module.exports = __webpack_public_path__ + "static/media/round-admin.269dc50d.jpeg";